import { FC } from "react";

import { VnBox } from "@/components/VnBox";
import { VnText } from "@/components/VnText/VnText";
import { I18nKeyType } from "@/i18n";
import { EligibilityHouseholdMembersIndicator } from "@/interactors/EligibilityHouseholdMembersIndicator";
import { cn } from "@/utils/tailwind";

import { BackButton } from "./BackButton";
import { ScreenLayout, ScreenLayoutPropsType } from "./ScreenLayout";

type EligibilityScreenLayoutPropsType = Pick<
  ScreenLayoutPropsType,
  "variant" | "scrollViewRef"
> & {
  children: React.ReactNode;
  shouldShowBackButton?: boolean;
  onBackButtonPress?: () => void;
  className?: string;
  titleI18nKey?: I18nKeyType;
  descriptionI18nKey?: I18nKeyType;
  titleI18nOptions?: Record<string, unknown>;
  descriptionI18nOptions?: Record<string, unknown>;
};

export const EligibilityScreenLayout: FC<EligibilityScreenLayoutPropsType> = ({
  children,
  shouldShowBackButton = true,
  onBackButtonPress,
  variant,
  className,
  titleI18nKey,
  descriptionI18nKey,
  titleI18nOptions,
  descriptionI18nOptions,
  scrollViewRef,
}) => {
  return (
    <VnBox className="bg-background h-full">
      <EligibilityHouseholdMembersIndicator />
      <ScreenLayout
        variant={variant}
        scrollViewRef={scrollViewRef}
        className="pb-6 md:max-w-screen-md"
        backgroundClassName="bg-background">
        <VnBox className="flex items-start pb-3 pt-6">
          {shouldShowBackButton ? (
            <BackButton variant="ghost" onPress={onBackButtonPress} />
          ) : (
            <VnBox className="h-9" />
          )}
        </VnBox>

        <VnBox className={cn("gap-6 px-2", className)}>
          {titleI18nKey && (
            <VnBox className="gap-2">
              <VnText
                variant="headerTwo"
                i18nKey={titleI18nKey}
                i18nOptions={titleI18nOptions}
              />

              {descriptionI18nKey && (
                <VnText
                  variant="lg"
                  className="text-muted-foreground"
                  i18nKey={descriptionI18nKey}
                  i18nOptions={descriptionI18nOptions}
                />
              )}
            </VnBox>
          )}

          {children}
        </VnBox>
      </ScreenLayout>
    </VnBox>
  );
};
